import React, { Component } from 'react'
import './table.css'

export default class Table extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fixedNum: 0,
      tableWidth: 0,
      fixedTableWidth: 0,
      scrollX: false,
      trHeights: [],
      thWidths: []
    }
  }
  componentDidMount() {
    const { columns, data } = this.props;
    let fixedNum = 0;
    for (let i = 0, len = columns.length; i < len; i++) {
      if (columns[i].fixed) {
        fixedNum++
      } else {
        break
      }
    }
    if (fixedNum) {
      const width = document.body.clientWidth;
      const avgWidth = width * 0.2;
      let len = columns.length;
      let counterWidth = 0;
      columns.forEach(col => {
        if (col.width) {
          counterWidth += typeof(col.width) === 'number' ? col.width : Number(col.width);
          len--
        }
      });
      this.setState(
        {
          tableWidth: avgWidth * len + counterWidth
        },
        () => {
          const trHeights = [];
          const thWidths = [];
          for (let i = 0, len = columns; i < len; i++) {
            if (this.refs['th' + i]) {
              thWidths.push(this.refs['th' + i].offsetWidth)
            }
          }
          for (let i = 0, len = data; i < len; i++) {
            if (this.refs['tr' + i]) {
              trHeights.push(this.refs['tr' + i].offsetHeight)
            }
          }
          this.setState({
            fixedNum,
            trHeights,
            thWidths
          })
        }
      )
    }
  }
  componentDidUpdate = () => {
    const { columns, data } = this.props;
    setTimeout(() => {
      const trHeights = [];
      const thWidths = [];
      for (let i = 0, len = columns.length; i < len; i++) {
        if (this.refs['th' + i]) {
          thWidths.push(this.refs['th' + i].offsetWidth)
        }
      }
      for (let i = 0, len = data.length + 1; i < len; i++) {
        if (this.refs['tr' + i]) {
          trHeights.push(this.refs['tr' + i].offsetHeight)
        }
      }
      this.setState({
        trHeights,
        thWidths
      })
    })
  };
  onScroll = e => {
    if (!this.state.scrollX && e.target.scrollLeft) {
      this.setState({
        scrollX: true
      })
    }
    if (this.state.scrollX && !e.target.scrollLeft) {
      this.setState({
        scrollX: false
      })
    }
  };
  onClick = index => {
    const { data } = this.state;
    this.props.onTrClick && this.props.onTrClick(index, data[index])
  };
  renderFixedTable = () => {
    const { fixedNum, fixedTableWidth, trHeights, thWidths } = this.state;
    const { columns, data,stripe } = this.props;
    if (!fixedNum) {
      return null
    }
    const currentColumns = columns.slice(0, fixedNum);
    const cols = [];
    // 固定行的宽度
    const fixedWidth = currentColumns.reduce((t,o) => t + (Number(o.width) || 0), 0) || fixedTableWidth;
    currentColumns.forEach((item, index) => {
      // let width = 0
      // if (this.refs['th' + index]) {
      //   width = this.refs['th' + index].offsetWidth
      // }
      cols.push(
        <col
          key={item.id + 'fixed'}
          align={item.align || 'right'}
          width={thWidths[index]}
        />
      );

    });
    // const trHeights = []
    // trHeights[0] = this.refs['tr0'] && this.refs['tr0'].offsetHeight
    // for (let i = 1, len = data.length; i < len; i++) {
    //   trHeights[i] = this.refs['tr' + i] && this.refs['tr' + i].offsetHeight
    // }

    return (
      <table
        // className="table-fixed cover"
        className={stripe ? 'table-stripe table-fixed cover' : 'table-fixed cover'}
        cellSpacing="0"
        bordercollapse="collapse"
        style={{
          width: fixedWidth
        }}
      >
        <colgroup>{cols}</colgroup>
        <thead>
          <tr style={{ height: trHeights[0] }}>
            {currentColumns.map(item => {
              return (
                <th key={item.id} align={item.align || 'right'}>
                  {item.title}
                </th>
              )
            })}
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => {
            let firstColumn = currentColumns[0];
            let rowSpan = 1;
            let trStyle = { height: trHeights[index + 1] };
            if (typeof item[firstColumn.id] === 'object') {
              rowSpan = item[firstColumn.id].rowSpan;
            }
            if (rowSpan > 1 || item[firstColumn.id] === undefined) {
              trStyle = {};
            }
            return (
              <tr
                onTouchStart={this.onTouchStart}
                onClick={() => {
                  this.onClick(index)
                }}
                key={index}
                style={trStyle}
              >
                {currentColumns.map(subItem => {
                  if (item[subItem.id] === undefined) {
                    return null
                  }
                  let subItemText = '';
                  if (typeof item[subItem.id] === 'object') {
                    subItemText = item[subItem.id].text;
                    rowSpan = item[subItem.id].rowSpan
                  } else {
                    subItemText = item[subItem.id]
                  }

                  let tdStyle = {};
                  let lineHight = 0;
                  if (trHeights[index + 1] && rowSpan > 1) {
                    for (let i = index; i < rowSpan + index; i++) {
                      lineHight += trHeights[i + 1]
                    }
                    tdStyle = { height: lineHight }
                  }

                  if (typeof subItem.render === 'function') {
                    return (
                      <td
                        rowSpan={rowSpan}
                        align={subItem.align || 'right'}
                        key={subItem.id}
                        style = {tdStyle}
                      >
                        {subItem.render(item[subItem.id], index, item)}
                      </td>
                    )
                  }
                  return (
                    <td
                      rowSpan={rowSpan}
                      align={subItem.align || 'right'}
                      key={subItem.id}
                      style = {tdStyle}
                    >
                      {subItemText}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  };

  componentWillUnmount() {
    this.setState = () => {

    }
  }

  render() {
    const { columns, data, stripe } = this.props;
    const { tableWidth } = this.state;
    let lastIndex = 0;
    return (
      <div className="c-table">
        <div
          onScroll={this.onScroll}
          className="table-main-container"
          style={{
            overflowX: 'scroll'
          }}
        >
          <table
            style={{
              width: tableWidth ? tableWidth : null
            }}
            // className="table-main"
            className={stripe ? 'table-stripe table-main' : 'table-main'}
            cellSpacing="0"
            bordercollapse="collapse"
          >
            <colgroup>
              {columns.map(item => {
                if (item.width) {
                  return (
                    <col
                      key={item.id}
                      align={item.align || 'right'}
                      width={item.width}
                    />
                  )
                } else {
                  return <col key={item.id} align={item.align || 'right'} />
                }
              })}
            </colgroup>
            <thead>
              <tr ref="tr0">
                {columns.map((item, index) => {
                  return (
                    <th
                      ref={'th' + index}
                      key={item.id}
                      align={item.align || 'right'}
                    >
                      {item.title}
                    </th>
                  )
                })}
              </tr>
            </thead>
            <tbody>
              {
                data.map((item, index) => {
                let defaultStyle = { borderBottom: '1px solid #ddd' };
                let noneStyle = { borderBottom: 'none' };
                let actualStyle = defaultStyle;
                return (
                  <tr
                    onClick={() => {
                      this.onClick(index)
                    }}
                    ref={'tr' + (index + 1)}
                    key={index}
                  >
                    {columns.map((subItem, subIndex) => {
                      if (item[subItem.id] === undefined) {
                        return null
                      }
                      let subItemText = '';
                      let rowSpan = 1;
                      if (typeof item[subItem.id] === 'object') {
                        subItemText = item[subItem.id].text;
                        rowSpan = item[subItem.id].rowSpan;
                        lastIndex = index + rowSpan;
                      } else {
                        subItemText = item[subItem.id]
                      }

                      if (index < lastIndex - 1) {
                        actualStyle = noneStyle
                      } else {
                        actualStyle = defaultStyle
                      }

                      if (typeof subItem.render === 'function') {
                        return (
                          <td
                            ref={'td' + (subIndex + 1)}
                            rowSpan={rowSpan}
                            align={subItem.align || 'right'}
                            key={subItem.id}
                            style={actualStyle}
                          >
                            {subItem.render(item, index)}
                          </td>
                        )
                      }
                      return (
                        <td
                          ref={'td' + (subIndex + 1)}
                          align={subItem.align || 'right'}
                          key={subItem.id}
                          rowSpan={rowSpan}
                          style={actualStyle}
                        >
                          {subItemText}
                        </td>
                      )
                    })}
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
        {this.renderFixedTable()}
      </div>
    )
  }
}
